<script setup lang="ts">
import EstateListing from '~/components/estate/listing/EstateListing.vue'
import { useFilterState } from '~/composables/filter/useFilterState'
import { usePaginationState } from '~/composables/pagination/usePaginationState'

const { t } = useI18n()
const paginationState = usePaginationState({
  type: 'estate',
})

const { filterValues } = useFilterState({ paginationState })

useHead({
  title: () =>
    t('pages.estateListing.header.titles.seoRetail', {
      _0: filterValues.value.search,
    }),
  meta: [
    {
      name: 'title',
      content: t('pages.estateListing.header.titles.seoRetail', {
        _0: filterValues.value.search,
      }),
    },
    {
      name: 'description',
      content: t('pages.estateListing.header.descriptions.retail'),
    },
  ],
})

useFancyHeader()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/retail',
    sk: '/obchodne-priestory',
  },
})
</script>

<template>
  <EstateListing estate-type="retail" />
</template>
